import { useLocalization } from "@fluent/react";
import { modules } from "byzantine";
import WireTemplateDrawer from "../WireTemplateDrawer/WireTemplateDrawer";
import InternationalWireTemplateForm from "./InternationalWireTemplateForm";

type InternationalWireTemplateDrawerProps = {
  isOpen: boolean;
  onDismiss: () => void;
  templateId?: API.SwiftWireTemplateId;
};

/**
 * Controlled drawer for creating or editing an international wire template.
 * Open/close state is managed by the parent container.
 */
const InternationalWireTemplateDrawer = ({
  isOpen,
  onDismiss,
  templateId,
}: InternationalWireTemplateDrawerProps) => {
  const { l10n } = useLocalization();
  return (
    <WireTemplateDrawer isOpen={isOpen} onDismiss={onDismiss}>
      <modules.internationalWires.UpsertInternationalTemplateFormProvider
        l10n={l10n}
      >
        <InternationalWireTemplateForm
          onDismiss={onDismiss}
          templateId={templateId}
        />
      </modules.internationalWires.UpsertInternationalTemplateFormProvider>
    </WireTemplateDrawer>
  );
};

export default InternationalWireTemplateDrawer;
